<template>
  <TButtonGroup>
    <TGroupButton
      data="align-left"
      tooltip="Align left"
      small
      toggle
      :active="editor.isActive({ textAlign: 'left' })"
      :inverse="inverse"
      @button-clicked="editor.chain().focus().setTextAlign('left').run()"
    >
      <TextLeft />
    </TGroupButton>
    <TGroupButton
      data="align-center"
      tooltip="Align center"
      small
      toggle
      :active="editor.isActive({ textAlign: 'center' })"
      :inverse="inverse"
      @button-clicked="setCenterAlign"
    >
      <TextCenter />
    </TGroupButton>
    <TGroupButton
      data="align-right"
      tooltip="Align right"
      small
      toggle
      :active="editor.isActive({ textAlign: 'right' })"
      :inverse="inverse"
      @button-clicked="editor.chain().focus().setTextAlign('right').run()"
    >
      <TextRight />
    </TGroupButton>
    <TGroupButton
      data="align-justify"
      tooltip="Justify"
      small
      toggle
      :active="editor.isActive({ textAlign: 'justify' })"
      :inverse="inverse"
      @button-clicked="editor.chain().focus().setTextAlign('justify').run()"
    >
      <TextCenter />
    </TGroupButton>
  </TButtonGroup>
</template>

<script lang="ts" setup>
import { Editor } from "@tiptap/core";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
import { TextLeft, TextCenter, TextRight } from "@topol/icons";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

function setCenterAlign() {
  if (!props.editor) return;
  props.editor.chain().focus().setTextAlign("center").run();
}
</script>
